/**
 * FreightPilotAI Landing Page — top-level composition.
 *
 * The heavy lifting (26 components, ~2200 lines pre-refactor) now lives
 * in `./landing/` split by page section. Keep this file thin so section
 * ordering + SEO copy are trivial to iterate.
 */
import { useSeoHead } from "./landing/utils";
import { StickyNav } from "./landing/Nav";
import { Hero } from "./landing/Hero";
import {
  AntiScamSection,
  LeaderboardWidget,
  TikToksWidget,
} from "./landing/AntiScam";
import {
  PricingTrustStrip,
  BenefitBar,
  ProblemSection,
  SolutionsSection,
  HowItWorks,
  TrustSection,
} from "./landing/Content";
import {
  PricingPreview,
  TestimonialsSection,
  FounderSection,
  FAQSection,
  FinalCTA,
} from "./landing/Conversion";
import { SiteFooter } from "./landing/Footer";
import ROICalculatorSection from "./landing/ROICalculator";
import FreeAssessmentSection from "./landing/FreeAssessment";
import WorkflowPreviewSection from "./landing/WorkflowPreview";

export default function LandingPage() {
  useSeoHead(
    "AI Automation for Trucking Companies | FreightPilotAI",
    "FreightPilotAI helps trucking companies reduce repetitive office work, streamline communication, process documents, and improve operational efficiency with practical AI automation.",
  );

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white noise-bg" data-testid="landing-page">
      <StickyNav />
      <main>
        {/* ────── ACT 1 · Hook + value promise ────── */}
        <Hero />
        <BenefitBar />
        <PricingTrustStrip />
        <WorkflowPreviewSection />

        {/* ────── ACT 2 · What we solve + how it works ────── */}
        <ProblemSection />
        <SolutionsSection />
        <HowItWorks />
        <ROICalculatorSection />

        {/* ────── ACT 3 · Proof + differentiation ────── */}
        <TrustSection />
        <AntiScamSection />
        <LeaderboardWidget />
        <TestimonialsSection />
        <FounderSection />

        {/* ────── ACT 4 · Offers + close ────── */}
        <PricingPreview />
        <FreeAssessmentSection />
        <TikToksWidget />
        <FAQSection />
        <FinalCTA />
      </main>
      <SiteFooter />
    </div>
  );
}
